// // import React from 'react';
// // import Sidebar from '../../../Employee/SideBar/SideBar';
// // import Navbar from '../../Navbar/Navbar';
// // import { Outlet } from 'react-router-dom';
// // import ChatButtonAndPopup from '../../../chat/ChatButtonAndPopup';

// // function EmployeeLayout() {
// //   return (
// //     <div className="employee-layout">
// //       {/* Sidebar */}
// //       <Sidebar />

// //       {/* Main Content */}
// //       <div className="employee-content">
// //         <Navbar />
// //         <div className="employee-main">
// //           <Outlet />
// //         </div>
// //       </div>

// //       {/* Floating Chat Button */}
// //       {/* <ChatButtonAndPopup /> */}
// //     </div>
// //   );
// // }

// // export default EmployeeLayout;

// import React from 'react';
// import Sidebar from '../../../Employee/SideBar/SideBar';
// import Navbar from '../../Navbar/Navbar';
// import { Outlet } from 'react-router-dom';

// function EmployeeLayout() {
//   return (
//     <div className="employee-layout" style={{ display: 'flex', minHeight: '100vh', width: '100%' }}>
//       {/* Sidebar - Fixed width 250px */}
//       <Sidebar />

//       {/* Main Content Area */}
//       <div 
//         className="employee-content" 
//         style={{ 
//           flexGrow: 1, 
//           marginLeft: '250px', // Matches sidebar width exactly
//           display: 'flex',
//           flexDirection: 'column',
//           width: 'calc(100% - 250px)',
//           minHeight: '100vh'
//         }}
//       >
//         {/* Navbar - Should be inside the content area to align with it */}
//         <Navbar />

//         {/* Page Content */}
//         <div 
//           className="employee-main" 
//           style={{ 
//             padding: '20px',
//             flexGrow: 1,
//             background: '#f8fafc'
//           }}
//         >
//           <Outlet />
//         </div>
//       </div>
//     </div>
//   );
// }

// export default EmployeeLayout;

import React from 'react';
import Sidebar from '../../../Employee/SideBar/SideBar';
import Navbar from '../../Navbar/Navbar';
import { Outlet } from 'react-router-dom';
import '../../employeeTheme.css';
import ChatButtonAndPopup from '../../../Admin/Components/Admin/ChatButtonAndPopup';
import ActivityTracker from '../../../utils/ActivityTracker';

function EmployeeLayout() {
  return (
    <div className="employee-layout-root">
      <ActivityTracker />
      <div className="employee-layout-sidebar-space">
        <Sidebar />
      </div>

      <div className="employee-layout-content">
        <Navbar />

        <div className="employee-layout-main">
          <Outlet />
        </div>
      </div>
      <ChatButtonAndPopup />
    </div>
  );
}

export default EmployeeLayout;
